<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Purchase and Activate Using a Prepaid Code
                <p class='text-caption text-italic' runat='server'>Applies to: {{ appliesToText }}</p>
            </div>


            <p>
                Once you have the software installed, follow these steps to purchase and activate
                your license using a Prepaid Code.
            </p>

            <p>
                If you need the setup file to install the software, go to the corresponding downloads page:
            </p>

            <ul style='list-style-type: none;' class='helpTable'>
                <li><router-link to='/Download/PlumbingCAD'>Download PlumbingCAD</router-link></li>
            </ul>

            <ol class='help-listStyle q-mt-lg'>

                <li>
                    Run the program
                    <span class='text-weight-medium'>on the computer that you want activated</span>.
                </li>
                <li>
                    <p>
                        If the Activation window does not automatically open, click the
                        <span class='text-weight-medium'>Activate</span> link.
                    </p>
                    <img class="img-fit" :src="require('@/assets/img/help/Activate Link.jpg')" />
                </li>
                <li>
                    <p>Click the '<span class='text-weight-medium'>Purchase a New License</span>' option. This will take you to the activation website.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/PurchaseNewLicenseLink.jpg')" />
                </li>
                <li>
                    <p>
                        The website will now open. Select the '<span class='text-weight-medium'>Purchase and Activate a new annual subscription</span>' option, then click
                        <span class='text-weight-medium'>Continue</span> to proceed.
                    </p>
                    <img class="img-fit" :src="require('@/assets/img/help/PCAD_Prepurchased option_Website.jpg')" />
                </li>
                <li>
                    <p>
                        Input your <span class='text-weight-medium'>Prepaid Code</span> in the field provided, including all dashes.
                    </p>
                    <img class="img-fit" :src="require('@/assets/img/help/PCAD_DiscountCode_Website.jpg')" />
                </li>
                <li>
                    Click <span class='text-weight-medium'>Continue</span> and follow the remaining steps to complete the purchase. If you do not have an online account yet, create a new one when prompted.
                </li>
                <li>
                    When you get to the Shopping Cart page, click <span class='text-weight-medium'>Continue</span> to proceed with the checkout process.
                </li>
                <li>
                    <p>When completed, the Activation Code will be displayed on screen and will also be sent to you by email.</p>
                    <p><img class="img-fit" :src="require('@/assets/img/help/ActivationCodeField.jpg')" /></p>
                    <p>For help on entering your new activation code, see the <router-link to='/Support/Help/Enter-Activation'>Entering an Activation Code</router-link> help topic.</p>
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'pcad-purchase-prepaid',
        data() {
            return {
                appliesToText: productLines.PlumbingCAD.name + ' ' + productLines.PlumbingCAD.year
            }
        }
    }
</script>

